import React, { useEffect } from 'react';
import UDHeaderTitle from 'ud-ui/components/header-title';
import Text from 'ud-ui/components/text';
import { useMainLayout } from 'ud-ui/layout/main/context';
import MigrationForm from '../components/migration-form';

const MigrationPage: React.FC = () => {
  const { setHeaderContent } = useMainLayout();

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Миграция </UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <div className="w-full px-6 py-4">
      <div className="row">
        <div className="w-full">
          <Text type="title-1" className="mb-4">
            Миграция данных между Supabase
          </Text>
          <Text type="subhead" className="mb-4">
            Эта страница позволяет мигрировать шаблоны и доски из одного экземпляра Supabase в другой. Укажите учетные данные для обоих
            экземпляров Supabase. ID турнира можно не указывать — в этом случае будет смигрирован стандартный шаблон (без owner_id).
          </Text>
          <MigrationForm />
        </div>
      </div>
    </div>
  );
};

export default MigrationPage;
